import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button, Stack, Text } from "@mantine/core";
import type { ICartItem } from "../stores/models/IBasketItem.models";
import type IBasketAccount from "../stores/models/IBasketItem.models";
import BasketAccountListItem from "./basket/BasketAccountListItem";

interface IBasketAccountListProps {
  accounts: IBasketAccount[];
  invalidAccounts: ICartItem[];
  deleteAccount: (account: IBasketAccount) => void;
  clearAccounts: () => void;
}

const BasketAccountList: React.FC<IBasketAccountListProps> = ({
  invalidAccounts,
  accounts,
  deleteAccount,
  clearAccounts,
}) => {
  const { t } = useAppTranslation("pages.order.basket.accountList");
  const isEmpty = () => accounts.length === 0;

  const isInvalid = (item: ICartItem): boolean => {
    return invalidAccounts.some(
      (invalid) =>
        invalid.game === item.game &&
        invalid.accountId === item.accountId &&
        invalid.productId === item.productId,
    );
  };

  return (
    <>
      {isEmpty() ? (
        <Text className="text-center text-primary-white">{t("empty")}</Text>
      ) : (
        <Stack gap={18}>
          {accounts.map((account) => (
            <BasketAccountListItem
              key={account.accountId + account.game}
              item={account}
              isInvalid={isInvalid(account)}
              onDelete={() => deleteAccount(account)}
            />
          ))}
          <Button
            className="w-full"
            variant="transparent"
            onClick={clearAccounts}
          >
            <Text className="font-inter text-primary-dark-text" size="sm">
              {t("clear")}
            </Text>
          </Button>
        </Stack>
      )}
    </>
  );
};

export default BasketAccountList;
